import { root } from './versions';

export const versions = {
  ...root,
};
